/*
Copyright (c) Hello Nutshell. All rights reserved.
Licensed for use on the purchasing merchant's Shopify store.
Redistribution, resale, sublicensing, repackaging, or inclusion in another
commercial section or theme library is prohibited without written permission.
Existing written license agreements control in the event of a conflict.
*/
(() => {
  if (customElements.get('ns-crystalarium-ring-size')) return;
  const keys = ['Ring Size', 'Requested Ring Size', 'Requested ring size', 'Resizing from', 'Resizing Required', '_Resizing from', '_Resizing Required'];
  const parseSize = value => {
    const text = String(value ?? '').trim();
    if (!/^\d+(?:\.\d+)?$/.test(text)) return null;
    const n = Number(text);
    return n > 0 && Number.isInteger(n * 4) ? n : null;
  };
  class RingSize extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      // Defer until the containing product form has been parsed/upgraded.
      queueMicrotask(() => this.isConnected && this.initialize());
    }
    disconnectedCallback() { this.abort?.abort(); }
    initialize() {
      this.form = document.getElementById(this.dataset.formId);
      this.choice = this.querySelector('[data-ring-choice]');
      this.status = this.querySelector('[data-ring-status]');
      if (!this.form || !this.choice) return;
      const signal = this.abort.signal;
      try { this.data = JSON.parse(this.querySelector('[data-ring-variants]').textContent); }
      catch { this.fail(); return; }
      const scope = this.closest('product-form');
      if (!scope || scope.querySelectorAll('ns-crystalarium-ring-size').length !== 1) { this.fail(); return; }
      const sizeOptions = this.data.options.map((name, index) =>
        ['current ring size', 'ring size', 'size'].includes(String(name).trim().toLowerCase()) ? index : -1
      ).filter(index => index >= 0);
      this.sizeIndex = sizeOptions.length === 1 ? sizeOptions[0] : -1;
      this.validData = this.sizeIndex >= 0 && this.data.count === this.data.variants.length &&
        new Set(this.data.variants.map(v => String(v.id))).size === this.data.count;
      scope.addEventListener('on:variant:change', event => {
        if (event.detail.form === this.form) this.sync(event.detail.variant?.id ?? null);
      }, {signal});
      this.choice.addEventListener('change', () => this.updateProperties(), {signal});
      this.form.addEventListener('submit', event => {
        const id = this.form.elements.namedItem('id')?.value;
        if (String(id) !== this.variantId) this.sync(id);
        if (!this.updateProperties()) {
          event.preventDefault(); event.stopImmediatePropagation(); this.choice.focus();
        }
      }, {capture: true, signal});
      this.form.addEventListener('formdata', event => {
        keys.forEach(k => event.formData.delete(`properties[${k}]`));
        if (this.result) Object.entries(this.result).forEach(([k,v]) => event.formData.set(`properties[${k}]`,v));
      }, {signal});
      this.sync(this.form.elements.namedItem('id')?.value);
    }
    clearProperties() {
      this.form.querySelectorAll('[data-ns-ring-property]').forEach(el => el.remove());
      this.result = null;
    }
    fail() {
      this.clearProperties();
      this.choice.disabled = true;
      this.status.textContent = 'Ring sizing is unavailable for this selection. Please contact us for help.';
      const guard = this.form.querySelector('[data-ns-ring-guard]');
      if (guard) guard.disabled = false;
    }
    sync(id) {
      this.variantId = String(id);
      const variant = this.data.variants.find(v => String(v.id) === String(id));
      this.current = this.validData && variant ? parseSize(variant.options[this.sizeIndex]) : null;
      this.variant = variant;
      this.choice.replaceChildren();
      if (this.current === null || this.current <= 2 || !variant.available) { this.fail(); return; }
      for (let q = this.current * 4 - 8; q <= this.current * 4 + 8; q++) {
        const option = document.createElement('option');
                option.value = String(q / 4); option.textContent = q === this.current * 4 ? `${option.value} — current ring size` : option.value; if (q === this.current * 4) option.dataset.current = '';
        this.choice.append(option);
      }
      this.choice.value = String(this.current);
      this.choice.disabled = false;
      this.updateProperties();
    }
    updateProperties() {
      this.clearProperties();
      const wanted = parseSize(this.choice.value);
      const id = this.form.elements.namedItem('id')?.value;
      if (!this.validData || !this.variant?.available || String(id) !== this.variantId ||
          wanted === null || this.current === null || Math.abs(wanted-this.current)>2) {
        this.fail(); return false;
      }
      this.result = wanted === this.current ? {'Ring Size':String(wanted)} :
        {'Requested ring size':String(wanted), '_Resizing from':String(this.current), '_Resizing Required':'Yes'};
      Object.entries(this.result).forEach(([key,value]) => {
        const field=document.createElement('input'); field.type='hidden';
        field.name=`properties[${key}]`; field.value=value; field.dataset.nsRingProperty='';
        this.form.append(field);
      });
      this.form.querySelector('[data-ns-ring-guard]').disabled = true;
      this.status.textContent = '';
      return true;
    }
  }
  customElements.define('ns-crystalarium-ring-size', RingSize);
})();
